<template>
  <standard-layout :header="'Rechnung' + (invoice ? ' ' + invoice.number : '')">
    <template v-slot:main v-if="invoice">
      <invoice-detail :invoice="invoice" :panel-layout="true"/>
      <div class="mt-3">
        <button class="btn btn-warning btn-sm"
                @click="$router.push({name: 'creditOnInvoice', params: {invoiceId: invoice.id}})"
                v-if="invoice.state === 'paid' && invoice.amount > 0">
          Gutschreiben
        </button>
        <button class="btn btn-success btn-sm m-1"
                v-if="invoice.state === 'pending'"
                @click="markAsPaid">
          Als bezahlt verbuchen
        </button>
        <button class="btn btn-success btn-sm m-1"
                v-if="invoice.state === 'pending'"
                @click="cancel">
          Stornieren
        </button>
      </div>
      <div v-if="relatedInvoices.length > 0" class="mt-3">
        <div class="h5">Zugehörige Rechnungen</div>
        <invoice-detail v-for="invoice in relatedInvoices" :key="invoice.id"
                        :invoice="invoice"
                        class="mt-2"/>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import InvoiceDetail from "./InvoiceDetail";

export default {
  components: {InvoiceDetail, StandardLayout},
  props: {
    id: String
  },
  data() {
    return {
      invoice: null,
      relatedInvoices: []
    }
  },
  computed: {
    header() {
      if (this.invoice) {
        return 'Rechnung ' + this.invoiceNumber
      }
      return 'Rechnungen'
    }
  },
  methods: {
    reloadInvoice() {
      this.$api.get(`/invoices/${this.id}`)
          .then(res => this.invoice = res.data)
          .catch(error => this.handleError(error))
    },
    markAsPaid() {
      this.$api.put(`/orders/${this.invoice.order.id}/mark-as-paid`)
          .then(() => {
            this.showInfo('Bestellung wurde bezahlt.')
            this.reloadInvoice()
          }).catch(err => this.handleError(err))
    },
    cancel() {
      this.$api.delete(`/orders/${this.invoice.order.id}`)
          .then(() => {
            this.showInfo('Die Rechnung wurde storniert.')
            this.reloadInvoice()
          })
          .catch((err) => this.handleError(err))
    },
    generateInvoiceAndSent() {
      this.$api.post(`/invoices`, {}, {
        params: {
          order: this.invoice.order.id
        }
      }).then(() => this.showInfo("Rechnung generiert und archiviert"))
          .catch(error => this.handleError(error))
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.reloadInvoice()
      }
    },
    invoice(newVal) {
      if (newVal) {
        if (newVal.order.relatedToOrderId)
          this.$api.get(`/invoices/related`, {params: {order: newVal.order.relatedToOrderId}})
              .then(res => this.relatedInvoices = res.data.filter(i => i.id !== this.invoice.id))
              .catch(err => this.handleError(err))
        else
          this.$api.get(`/invoices/related`, {params: {order: newVal.order.id}})
              .then(res => this.relatedInvoices = res.data.filter(i => i.id !== this.invoice.id))
              .catch(err => this.handleError(err))
      }
    }
  }
}
</script>
